import styled from "@emotion/styled";
import {getImageUrl} from "../../context/ApplicationContextProvider";

export const ROUND_BOX = ({children, className}) => {
    const RoundDiv = styled.div((props) => ({
        padding: ".4em .8em",
        border: `1px solid ${props.theme.colors.lg3}`,
        borderRadius: "20px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 0,
    }));

    return <RoundDiv className={className}>{children}</RoundDiv>;
};

export const SECRET_NOTE = ({className}) => {
    const SecretNoteWrapper = styled.div((props) => ({
        outline: "none",
        width: "7em",
        height: "2.5em",
        boxSizing: "border-box",
        border: `1px solid ${props.theme.colors.lg3}`,
        borderRadius: ".3em",
        fontSize: props.theme.font_size.f15,
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: props.theme.colors.w,
        backgroundColor: props.theme.colors.black,
        "& span": {
            textAlign: "center",
            paddingLeft: ".4em",
        },
        "& .download-icon": {
            width: "30%",
            height: "100%",
            background: `url(${getImageUrl("image/course/ic_download_white.png")}) center center/contain no-repeat`,
        },
    }));

    return (
        <SecretNoteWrapper className={className}>
            <span>비법노트</span>
            <div className="download-icon" />
        </SecretNoteWrapper>
    );
};

export const BLUE_SQUARE_BOX = ({children, className}) => {
    const BlueSquareDiv = styled.div((props) => ({
        width: "100%",
        height: "3em",
        cursor: "pointer",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: props.theme.colors.w,
        backgroundColor: props.theme.colors.bearu_primary,
        borderRadius: ".5em",
        "&:hover": {
            backgroundColor: props.theme.colors.active_button,
        },
        span: {
            fontSize: props.theme.font_size.f17,
            fontWeight: "bold",
        },
    }));

    return <BlueSquareDiv className={className}>{children}</BlueSquareDiv>;
};
